import React from 'react';
import styles from '../../assets/css/cards/card-body.module.css';
import PropTypes from 'prop-types';

const CardBody = ({ children, variant, component, padding, mt }) => {
    const CLASSTEXT = {
        center: styles.text_center,
        start: styles.text_start,
        end: styles.text_end
    };
    const PDTOP = {
        1: styles.pd__1,
        2: styles.pd__2,
        3: styles.pd__3,
        4: styles.pd__4,
        5: styles.pd__5
    };
    const MARGINTOP = {
        1: styles.mt__top_1,
        2: styles.mt__top_2,
        3: styles.mt__top_3,
        4: styles.mt__top_4,
        5: styles.mt__top_5
    };

    const CustomTag = `${component}`;

    return (
        <div
            className={`${styles.body__container} ${CLASSTEXT[variant] || ''} ${
                PDTOP[padding] || ''
            }`}>
            <CustomTag
                className={`${MARGINTOP[mt] || ''} ${
                    component === 'hr' && styles.small
                }`}>
                {children}
            </CustomTag>
        </div>
    );
};
CardBody.propTypes = {
    children: PropTypes.node,
    variant: PropTypes.string,
    component: PropTypes.string,
    padding: PropTypes.number,
    pdButtom: PropTypes.number,
    mt: PropTypes.number
};
export default CardBody;
